import React, { useEffect, useState } from "react";

import "./PolicyRegistry.css";

import PolicyTable from "../components/PolicyTable";

import CreatePolicyModal from "../modals/CreatePolicyModal";
import CreateVersionModal from "../modals/CreateVersionModal";
import PolicyVersionsModal from "../modals/PolicyVersionsModal";
import PolicySimulatorModal from "../modals/PolicySimulatorModal";

import usePolicies from "../hooks/usePolicies";
import { useAuth } from "../../../context/AuthContext";
import { API_BASE } from "../../../config";

export default function PolicyRegistry() {
  const { token, tenant } = useAuth();

  //
  // authentication context
  //
  const [apiKey, setApiKey] = useState("");
  const [tenantId, setTenantId] = useState("");

  //
  // pagination
  //
  const [page, setPage] = useState(0);
  const [pageSize] = useState(10);

  //
  // search
  //
  const [search, setSearch] = useState("");

  //
  // modals
  //
  const [showCreateModal, setShowCreateModal] =
    useState(false);

  const [showVersionModal, setShowVersionModal] =
    useState(false);

  const [showVersionsModal, setShowVersionsModal] =
    useState(false);

  const [showSimulatorModal, setShowSimulatorModal] =
    useState(false);

  //
  // selected policy
  //
  const [selectedPolicyId, setSelectedPolicyId] =
    useState(null);

  const [selectedPolicy, setSelectedPolicy] =
    useState(null);

  //
  // load auth
  //
  useEffect(() => {
    if (tenant?.uid) {
      setTenantId(tenant.uid);
    } else {
      const savedTenantUid = localStorage.getItem("vaultize_tenant_uid");
      if (savedTenantUid) setTenantId(savedTenantUid);
    }

    const savedApiKey = localStorage.getItem("vaultize_api_key");
    if (savedApiKey) {
      setApiKey(savedApiKey);
    } else if (token) {
      fetch(`${API_BASE}/dashboard/api-keys`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => res.ok ? res.json() : [])
      .then(keys => {
        if (Array.isArray(keys) && keys.length > 0) {
          const activeKey = keys.find(k => (k.enabled && !k.revoked)) || keys[0];
          const val = activeKey.apiKeyPreview || activeKey.apiKey || activeKey.maskedKey;
          if (val) setApiKey(val);
        }
      })
      .catch(() => {});
    }
  }, [tenant, token]);

  //
  // policies hook
  //
  const {
    policies,
    totalCount,
    loading,
    error,
    refresh
  } = usePolicies(
    apiKey,
    tenantId,
    page,
    pageSize,
    search
  );

  //
  // create version
  //
  function openVersionModal(policy) {

    setSelectedPolicyId(
      policy.policyId
    );

    setShowVersionModal(true);
  }

  //
  // show versions
  //
  function openVersionsModal(policy) {

    setSelectedPolicy(policy);

    setShowVersionsModal(true);
  }

  return (

    <section className="policy-page">

      <div className="container">

        <h1 className="policy-title">
          Policy Administration
        </h1>

        <p className="policy-subtitle">
          Manage access policies and versions
        </p>

        <div className="policy-toolbar">

          <button
            className="btn btn-primary"
            onClick={() =>
              setShowCreateModal(true)
            }
          >
            Create Policy
          </button>

          <button
            className="btn btn-secondary"
            onClick={() =>
              setShowSimulatorModal(true)
            }
            style={{ marginLeft: "0.5rem" }}
          >
            🛡️ Simulate Policies
          </button>

          <input
            className="search-input"
            placeholder="Search policies"
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

        </div>

        {error && (

          <div className="policy-error">
            {error}
          </div>

        )}

        <PolicyTable
          policies={policies}
          loading={loading}
          page={page}
          pageSize={pageSize}
          totalCount={totalCount}
          onPageChange={setPage}
          onCreateVersion={openVersionModal}
          onShowVersions={openVersionsModal}
          refresh={refresh}
        />

        {/* Create Policy */}

        {
          showCreateModal && (

            <CreatePolicyModal
              apiKey={apiKey}
              tenantId={tenantId}
              onClose={() =>
                setShowCreateModal(false)
              }
              onSaved={refresh}
            />

          )
        }

        {/* Create Version */}

        {
          showVersionModal &&
          selectedPolicyId && (

            <CreateVersionModal
              policyId={selectedPolicyId}
              apiKey={apiKey}
              tenantId={tenantId}
              onClose={() =>
                setShowVersionModal(false)
              }
              onSaved={refresh}
            />

          )
        }

        {/* Show Versions */}

        {
          showVersionsModal &&
          selectedPolicy && (

            <PolicyVersionsModal
              policyId={selectedPolicy.policyId}
              apiKey={apiKey}
              tenantId={tenantId}
              onClose={() =>
                setShowVersionsModal(false)
              }
            />

          )
        }

        <PolicySimulatorModal
          isOpen={showSimulatorModal}
          onClose={() => setShowSimulatorModal(false)}
          apiKey={apiKey}
          tenantId={tenantId}
        />

      </div>

    </section>

  );
}